import * as React from "react";
import { AuditTrailEntity, AuditTrailEntityDetail } from "../misc/api/apiTypes";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import { ExpandableTableRow } from "./ExpandableTableRow";

export interface EventModificationDetailsProps {
    entities: Array<AuditTrailEntity>;
}

export const EventModificationDetails = ({ entities }: EventModificationDetailsProps) => {
    const renderEntityDetailItem = (detail: AuditTrailEntityDetail) => {
        return (
            <p
                key={`${detail.PropertyName}_Block`}
                style={{ wordWrap: "break-word", width: 80 + "%" }}
            >
                <b>{detail.PropertyName}: </b>
                <del>{detail.OriginalValue}</del> <ins>{detail.NewValue}</ins>
            </p>
        );
    };

    const renderNoEntitiesAlert = () => {
        return (
            <Alert show={true} category={AlertCategoryEnum.Info}>
                No entries
            </Alert>
        );
    };

    const renderNoDetailsAlert = () => {
        return (
            <Alert show={true} category={AlertCategoryEnum.Info}>
                Details were not logged.This scenario may occur if the Audit Trail Event is related
                to a database tables relationship change.Read the <em> Additional Log Details</em>{" "}
                in the <a href="#details"> Details section</a> for more info about this log event.
            </Alert>
        );
    };

    const renderEntityItem = (entity: AuditTrailEntity) => {
        const expandedContent = (
            <div>
                {entity.Details.length == 0 ? renderNoDetailsAlert() : null}
                {entity.Details.map(d => renderEntityDetailItem(d))}
            </div>
        );

        return (
            <ExpandableTableRow
                key={`${entity.Id}_ExpandableRow`}
                expandedContent={expandedContent}
            >
                <>
                    <td>{entity.TypeName}</td>
                    <td>{entity.ActionDescription}</td>
                    <td>{entity.RecordId}</td>
                </>
            </ExpandableTableRow>
        );
    };

    return (
        <div className="panel panel-default">
            <div className="panel-heading">Modifications</div>
            <div className="panel-body">
                {entities.length == 0 ? (
                    renderNoEntitiesAlert()
                ) : (
                    <table
                        id="eventTable"
                        className="table table-striped table-hover tablet breakpoint"
                    >
                        <thead>
                                <tr>
                                <th></th>
                                <th>Entity</th>
                                <th>Action</th>
                                <th>Key</th>
                            </tr>
                        </thead>
                        <tbody>{entities.map(e => renderEntityItem(e))}</tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
